import { useCallback } from 'react';

import { useHistory, useLocation } from 'react-router-dom';

import { setSignInLandingPage } from 'apps/customer/state/route';

import { appendSearchParams } from './appendSearchParams';
import { setIsFlowComplete, setIsReturningUser } from './onboardingSession';
import { OnboardingStep } from './OnboardingStep';
import { PATH_FOR_STEP } from './stepRoutes';

import type { FlowNextAction } from './flowResolution';

export function useSignInOnboardingNavigation() {
  const history = useHistory();
  const location = useLocation();

  const finish = useCallback(
    (path: string, { replace = false }: { replace?: boolean } = {}) => {
      setIsReturningUser(null);
      setIsFlowComplete(false);
      setSignInLandingPage(null);
      const destination = appendSearchParams(path, location.search);
      if (replace) history.replace(destination);
      else history.push(destination);
    },
    [history, location.search],
  );

  const navigate = useCallback(
    (action: FlowNextAction) => {
      if (action.type === 'step') {
        history.push(appendSearchParams(PATH_FOR_STEP[action.step], location.search));
        return;
      }
      if (action.type === 'external') {
        finish(action.path);
        return;
      }
      setIsFlowComplete(true);
      history.push(appendSearchParams(PATH_FOR_STEP[OnboardingStep.Success], location.search));
    },
    [finish, history, location.search],
  );

  return { finish, navigate };
}
